import jokeSphereVertexShader from '../components/view3D/glsl/joke-sphere.vert.glsl';
import jokeSphereFragmentShader from '../components/view3D/glsl/joke-sphere.frag.glsl';
import dottedDiskVertexShader from '../components/view3D/glsl/dotted-disk.vert.glsl';
import dottedDiskFragmentShader from '../components/view3D/glsl/dotted-disk.frag.glsl';
import flatColorVertexShader from '../components/view3D/glsl/flat-color.vert.glsl';
import flatColorFragmentShader from '../components/view3D/glsl/flat-color.frag.glsl';
import labelVertexShader from '../components/view3D/glsl/label.vert.glsl';
import labelFragmentShader from '../components/view3D/glsl/label.frag.glsl';
import backgroundVertexShader from '../components/view3D/glsl/background.vert.glsl';
import backgroundFragmentShader from '../components/view3D/glsl/background.frag.glsl';

export const AssetList = {
  jokeSphereVertexShader,
  jokeSphereFragmentShader,

  dottedDiskVertexShader,
  dottedDiskFragmentShader,

  flatColorVertexShader,
  flatColorFragmentShader,

  labelVertexShader,
  labelFragmentShader,

  backgroundVertexShader,
  backgroundFragmentShader,

  geoSphere: 'assets/models/geosphere.glb',

  gridTexture: 'assets/images/textures/grid.png',

  audioBasicMode: 'assets/audio/frauhhofer_basicmode.mp3',
  audioAdvancedMode: 'assets/audio/frauhhofer_advancedmode.mp3',
  audioCTA: 'assets/audio/frauhhofer_cta.mp3',
  audioCTAHover: 'assets/audio/frauhhofer_cta_hover.mp3',
  // audioCTAHover: 'assets/audio/frauhhofer_hover_effect_itsnojoke.mp3',
  audioMenuOpenClose: 'assets/audio/frauhhofer_menu_open_close.mp3',
  audioNextPrev: 'assets/audio/frauhhofer_next_prev.mp3',
  audioSendJoke: 'assets/audio/frauhhofer_sendjoke.mp3',
  audioSkipReplay: 'assets/audio/frauhhofer_skipreplay.mp3',
  audioSphereRotation: 'assets/audio/frauhhofer_sphererotation.mp3',
};